import { observable } from 'mobx';
import { AlunoModel } from '../Aluno';
import { ProfessorModel } from '../Professor';

export enum SituacaoDoPreProjeto {
    inexistente = -1,
    pendente = 0,
    aprovado = 1,
    recusado = 2,
}

export class PreProjetoModel {
    readonly id: number = 0;
    @observable public tema: string = '';
    @observable public parametroPreProjetoId: number = 0;
    @observable public titulo: string = '';
    @observable public justificativa: string = '';
    @observable public desenvolvimento: string = '';
    @observable public bibliografia: string = '';
    @observable public orientadores?: Array<OrientadorModel> = [];
    @observable public situacao?: SituacaoDoPreProjeto = SituacaoDoPreProjeto.inexistente;
    @observable public aluno: AlunoModel = new AlunoModel();
}

export class OrientadorModel {
    readonly id: number = 0;
    @observable public preProjetoId: number = 0;
    @observable public preProjeto: PreProjetoModel = new PreProjetoModel();
    @observable public professorId: number = 0;
    @observable public professor: ProfessorModel = new ProfessorModel();
    @observable public ordemParaConvite: number = 0;
    @observable public conviteEnviado: boolean = false;
    @observable public conviteAceito: boolean;
    @observable public dataDaResposta?: Date;
    @observable public dataDoEnvio?: Date;
    @observable public justificativaReprovacao?: string = '';
}

export class ParametroPreProjetoModel {
    readonly id: number = 0;
    @observable public serie: string = '';
    @observable public dataDeInicio: Date;
    @observable public dataDeFim: Date;
    @observable public dataDeInicioInscricoes: Date;
    @observable public dataDeFimInscricoes: Date;
    @observable public dataDeInicioPF: Date;
    @observable public dataDeFimPF: Date;
    @observable public dataDeInicioSF: Date;
    @observable public dataDeFimSF: Date;
    @observable public dataDeInicioTF: Date;
    @observable public dataDeFimTF: Date;
    @observable public observacao: string;
}

export class VagasRestantesProfessor {
    @observable public vagas: number;
}